export const TRANSLATIONS_EN = {
  welcome: "Welcome!",
  welcome1: "To keep connected with us please login with your personal info",
  loginTitle: "Login",
  signupTitle: "Company Sign Up",
  signup: "Sign Up",
  home: "Home",
  search: "search",
  ok: "Ok",
  add: "Add",
  send: "Send",
  cancel: "Cancel",
  reset: "Reset",
  verify: "Verify",
  save: "Save",
  edit: "Edit",
  next: "Next",
  previous: "Previous",
  back: "Back",
  editNext: "Edit & Next",
  submit: "Submit",
  finish: "Finish",
  upload: "Upload",
  print: "Print",
  delete: "Delete",
  download: "Download",
  login: "Login",
  done: "Done",
  goTitle: "Let’s go!",
  go: "Go",
  go_to_app: "Go to App",
  back_to_app: "Back to my app",
  dashboard: "Dashboard",
  activityLog: "Activity Log",
  settings: "Settings",
  searchCompany: "Search Company",
  company_detail: "Company Detail",
  myCompany: "My Company",
  more_company_detail: "Share some more company details",
  keep_me_login: "Keep me logged in on this device",
  dont_have_acc: "Don't Have An Account Yet?",
  dont_verify_acc: "Didn't Verify Account Yet?",
  clickUp: "Already playing with Pharma Linkage?",
  login_successfull: "Succesfully login!",
  i_accept_the:
    "By creating this account I agree to Pharma Linkage business platform's",
  terms_and_conditions: " Terms and Conditions",
  facility: "Facility",
  manufacturingFacility: "Manufacturing Facility",
  viewManufacturingFacility: "View Manufacturing Facility",
  manufacturingFacilityName: "Mfg Facility Name",
  manufacturingSites: "Manufacturing Sites",
  sinceEstablished: "Since Established",
  managefacility: "Manage facility",
  addfacility: "Add facility",
  Facilitypresentation: "Facility Presentation",
  request_forCredentials: "Request for Credentials",
  register_confirm_msg: "Congratulations! Your compnay is registerd with us.",
  request_confirm_msg:
    "Your request is send to your company admin sucessfully.",
  sendRequest: "Send Request",
  verify_account: "Account Verification",
  verify_account_msg: "Please verify your email using verification code.",
  sendOTP: "Send OTP",
  emailed: "We just emailed you.",
  val_emailed: "Please Enter The Code We Emailed You.",
  confirmationCode: "Confirmation code",
  resendOTP: "Resend OTP",
  verify_successful: "Verification Successful!",
  request_successful: "Request Submitted Successfully!",
  request_successful_text:
    "Once your admin will approve request you will get password reset link on your email",
  congratultions: "Congratultions!",
  register_successful: "Welcome to Pharma Linkage.",
  registration_successfull: "Registration Successfull!",
  registration_successfull_msg:
    "Please check your registered email for email verification.",
  forgot_password: "Forgot Password",
  forgot_password_msg:
    "Enter your email address and we will send you a link to reset your password",
  mailSent_successfull: "Mail has been sent to your registered email",
  resetLink_msg: "Reset password link sent to your registered email address",
  create_new_password: "Create New Password",
  changePassword_successfull: "Password changed!",
  changePassword_confirm_msg: "Your password has been changed successfully.",
  password_notconfirm_msg: "The two passwords that you entered do not match!",
  passsword_conditions:
    "Password should be minimum 8 characters, at least one letter and one number and one special character.",
  new_company_registration: "New Company Registration",
  manageUsers: "Manage users",
  manageUser: "Manage user",
  manageUsersRequest: "Manage Users Request",
  addUser: "Add User",
  changePassword: "Change Password",
  myProfie: "My Profile",
  PersonaInfo: "Personal info",
  profile_completenes: "Your Profile Completeness",
  manageCompany: "Manage Company",

  companyKeypersons: "Company Key Persons",
  company_corporatePresentation: "Company Corporate Presentation",
  uploadPDF: "Upload PPT/PDF",
  upload_fileSize: "Maximum file size: 2 MB",
  upload_fileSizeErr: "Image must smaller than 2 MB!",
  image_deleted_success: "Image delete successfully",
  videolink_URL: "Video link URL",
  Company_establishmentDate: "Company Establishment Date",
  no_of_manufacturingFacilities: "No. Of Manufacturing Facilities",
  employees: "Employees",
  updatePassword: "Update Password",
  userName: "UserName",
  firstName: "First Name",
  lastName: "Last Name",
  aboutMe: "About Me",

  businessLounge: " Business Lounge",
  whatsappNo: "Phone / WhatsApp No.",
  whatsapp_tooltip:
    "You can change your mobile number from profile edit option",
  verifyMobile: "Please verify your mobile",
  we_just_message_you: "We just message you.",
  enter_OTP_we_message_you: "Please enter the OTP we message you.",
  enterOTP: "Enter OTP",
  didnt_recieve_code: "Didn't Recieve OTP?",
  time_remaining: "Time Remaining",

  support: "Support",
  tickets: "Tickets",
  create_ticket: "Create Ticket",
  manage_ticket: "Manage Ticket",
  inprocess: "Inprocess",
  closed: "Closed",
  resolved: "Resolved",
  need_help: "Need some help?",
  need_help_msg1:
    "Check out our documentation or reach out to our support team via",
  need_help_msg2: "the form below. We’re happy to help!",
  describe_issue:
    "Please describe your question or issue in detail. include any attachments via URL (using a service like dropbox or google drive).",
  send_request: "Send Request",
  send_ticket_successfull: "Your Support Ticket Submitted!",
  ticket_mail_sent: "Our team will revert on it as soon as early",
  update_ticket_successfull: "Ticket updated successfully",

  sentInquiry: "Sent Inquiry",
  receivedInquiry: "Received Inquiry",
  inquiryList: "Inquiry list",

  concierge_service: "Concierge service",
  request_for_price: "Request for price",
  price_requested: "Price Requested",
  concierge_service_lbl1:
    "We provide a better linkage experience with our kit and have something for you as well. Choose the best suited kit plan.",
  sell_globally_service: "Sell Globally service with Pharma Linkage concierge",
  business_lounge_service:
    " Business Lounge service with Pharma Linkage concierge",
  bespoke_service: "Bespoke service with Pharma Linkage concierge",

  manageConciergeService: "Manage Concierge Service",
  addConciergeService: "Add Concierge Service",
  editConciergeService: "Edit Concierge Service",

  requestedConcierge: "Requested Concierge",
  purchasedConcierge: "Purchased Concierge",
  payment_fail: "Unfortunately, the payment for this order has failed",
  payment_successful:
    "Your payment was successful.  Your subscription will be updated in your account.",
  back_to_concierge: "back to concierge",
  buyNow: "Buy Now",
  invoice: "Invoice",
  download_sample_format: "Download Sample Format",
  upload_excel_option: "Bulk Upload",
  err_uploadSuccess: "Error in CSV Upload",
  msg_uploadSuccess: "CSV Uploaded Successfully",

  subscription: "Subscription",
  addSubscription: "Add Subscription",
  editSubscription: "Edit Subscription",

  purchasedsubscription: "Purchased Subscription",
  addPurchasedSubscription: "Add Purchased Subscription",
  editPurchasedSubscription: "Edit Purchased Subscription",

  companyList: "Company list",
  shortlistedCompany: "Shortlisted Company",

  //Login with OTP Page
  registered_email_label: "Please enter your registered email address",
  registered_mobile_label: "Please enter your registered mobile number",
  login_otp_label: "Login with OTP",
  //OTP verification Page
  otp_verification_label: "OTP Verification",
  otp_sent_mobile_label: "OTP has been sent on mobile",
  otp_sent_email_label: "OTP has been sent on Email",
  please_verify_below: " Please verify it below",
  //login Page
  welcome_back: "Welcome Back!",

  login_to_continue: "Login to continue",
  keep_me_logged_in_on_this_device: "Keep me logged in on this device",
  or: "OR",

  //pincode page
  pincode: "Pin Code",
  import: "Import",
  drag_drop_csv_file: "Drag and drop your CSV file here",
  select_file_from_your_computer: "Or select file from your computer",
  maximum_file_size: "Maximum file size: 2mb (.csv)",
  download_sample_file: "Download Sample File From Here.",
  get_csv_sample: "Get Csv Sample",
  pl_archived_pincode: "Archived Pin Code",
  error_in_list_pincode: "Error in List Pincode",
  pl_add_pincode: "Add Pin Code",
  //category page
  pl_category: "Category",
  pl_subcategory: "Sub Category",
  label_category_name: "Category Name",
  pl_category_name: "Enter category name",
  val_category_name: "Please enter valid category name",

  label_subcategory_name: "Sub Category Name",
  pl_subcategory_name: "Enter Sub category name",
  val_subcategory_name: "Please enter valid sub category name",

  label_description: "Description",
  pl_description: "Enter your description",
  archiveList: "Archived",
  archiveList1: "Archived Material Type",
  label_site1: "Select City",
  label_cit: "City",
  pl_department: "Department",
  place_department: "Enter your department",
  pl_gst_no1: "Enter state GST number",

  archived_category: "Archived category",
  category_added_successfully: "Category added successfully",
  category_update_successfully: "Category updated successfully",

  sub_category_added_successfully: "Sub category added successfully",
  sub_category_update_successfully: "Sub category updated successfully",

  error_in_add_category_list: "Error in add category list",
  error_in_list_category: "Error in list category",
  error_in_displaying_data: "Error in displaying data",
  category_restore_successfully: "Category restore successfully",
  category_restore_successfully4: "Category restored successfully",

  sub_category_restore_successfully: "Sub category restored successfully",
  sub_category_restore_successfully4: "Sub category restored successfully",

  error_in_restore_category: "Error in restore category",
  error_in_restore_sub_category: "Error in restore sub category",
  category_archive_successfully: "Category archive successfully",
  category_archive_successfully4: "Category archived successfully",
  sub_category_archive_successfully4: "Sub category archived successfully",
  error_in_delete_category: "Error in delete category",
  error_in_update_category_list: "Error in updating category list",
  error_in_delete_sub_category: "Error in delete sub category",
  pl_add_category: "Add Category",
  pl_edit_category: "Edit Category",
  archived_vendor_onboarding1: "Archived Vendors",
  are_you_sure_to_restore: "Are you sure to restore?",
  //Category Item Setting

  category_setting_added_successfully: "Category setting added successfully",
  category_setting_updated_successfully:
    "Category setting updated successfully",
  // AddZoneModel page
  zone_name_added_successfully: "Zone name added successfully",
  zone_name_updated_successfully: "Zone name updated successfully",

  zone_name_added_successfully2: "Zone added successfully",
  zone_name_updated_successfully2: "Zone updated successfully",

  error_in_adding_zone_name: "Error in adding zone name",
  error_in_updating_zone_name: "Error in updating zone name",
  zone_name_already_exist: "Zone name already exist",

  //Zone List page

  error_in_zone_list: "Error in zone list",
  zone_archive_successfully: "Zone archived successfully",
  zone: "Zone",
  archived_zone_list: "Archived zone list",
  error_in_archive: "Error in archive zone list",

  //Archive Zone Page

  zone_restore_successfully: "Zone restored successfully",
  error_in_restore_zone: "Error in restore zone",

  // Archive Delivery List page

  error_in_archive_list: "Error in Archive List",
  delivery_address_restore_successfully: "Site location restored successfully",
  error_in_restore_delivery_address: "Error in restore site location",

  //CompanyAddressList page
  error_in_company_adress_list: "Error in site location list",
  delivery_address_archive_successfully: "Site location archived successfully",

  error_in_archive_delivery_address: "Error in Archive Site Location",

  //Requesteddemolist page
  pl_requested_demo_date_time: "Demo Request Date & Time",
  pl_requested_demo_date_time4: "Demo Date & Time",
  place_note: "Add your notes here",
  error_in_requested_demo_list: "Error in Requested Demo List",
  status_updated_sucessfully: "Status updated sucessfully",
  requested_demo_archive_successfully: "Requested Demo Archived Successfully",
  error_in_archive_requested_demo: "Error in Archive Requested Demo",
  error_in_requested_demo_list_status_count:
    "Error in Requested Demo List Status Count",
  pl_requested_status_approached: "Status Approached",
  pl_requested_status_proposal: "Status Proposal",
  pl_requested_status_award: "Status Award",
  pl_requested_status_discard: "Status Discard",
  pl_enter_communication_detail: "Communication Detail",
  label_remark: "Enter Remark",
  pl_enter_remark: "Enter detail",
  label_document_upload: "Document Upload",
  val_document_upload: "Please upload document",
  status_changed_successfully: "Status Changed Successfully",
  error_in_changing_status: "Status not changed",
  val_remark: "Please enter remark",
  val_detail: "Please enter detail",
  label_upload_proposal: "Upload Proposal",
  //requesteddemo modal page

  error_in_updating_demo_list: "Error in Updating Demo List",
  demo_list_updated_successfully: "Demo List Updated Successfully",
  demo_list_updated_successfully1: "Demo Request Added Successfully",

  //requesteddemo filter modal page
  pl_requested_demo_filter: "Requested Demo Filter",
  pl_status: "Status",
  pl_select_status: "None",
  filter: "Filter",
  pl_max_date: "End Date",
  pl_min_date: "Start Date",

  //Roles List
  error_in_user_role: "Error in User Role",
  error_in_archive_user_role: "Error in Archive User Role",
  user_role_archive_successfully: "User Role Archive Successfully",
  error_in_restore_role: "Error in Restore User Role",
  role_restore_successfully: "User Role Restore Successfully",

  //adduserrole
  user_role_added_successfully: "User Role Added Succcessfully",
  user_role_updated_successfully: "User Role Updated Successfully",
  please_select_permission: "Please Select Permission",
  user_role_delete_successfully: "User Role Delete Successfully",
  error_in_delete_user_role: "Error in Delete User Role",

  //company documents List page
  eroor_in_company_document_list: "Error in Client Document List",
  company_document_archive_successfully: "Client Document Archive Successfully",

  //  ArchiveCompanyDocuments
  company_document_restore_successfully: "Client Document Restore Successfully",
  error_in_restore_company_document: "Error in Restore Client Document",

  //AddDocuments
  error_in_company_documents_list: "Error in Client Documents List",
  company_documents_added_successfully: "Client Documents Added Successfully",
  company_documents_updated_successfully:
    "Client Documents Updated Successfully",
  error_in_add_company_documents: "Error in add client documents",
  documents: "Documents",
  val_file: "Please Upload Document",

  //RFQ page
  pl_rfq: "RFQ",
  pl_add_rfq: "Add RFQ",
  rfq_history: " RFQ - History",
  label_estimated_price: "Estimated Price",
  val_estimated_price: "Please Added Estimated Price",
  val_estimated_price1: "Please add estimated Price",

  pl_estimated_price: "Estimated Price",
  pl_rfq_history: "RFQ History",
  po_summary: "Purchase Order Summary",
  val_amount_cap: "Please Enter Amount Cap",
  val_price_cap_timeline: "Please Enter Timeline Cap/ Price Validity (₹)",
  val_price_cap: "Please Enter Price Cap",

  est_label_code: "Estimated Price",
  est_pl_code: "Enter Estimated Price",

  val_timeline_cap: "Please Enter Timeline Cap/ Price Validity",

  rfq_float_for_price_submission: "Re-float for price submission",

  archive_RFQ_history: "Archive RFQ History",
  rfq_history_restore_successfully: "RFQ Restored Successfully",
  error_in_archive_rfq_history: "Error in Archive RFQ History",
  error_in_restore_rfq_history: "Error in Restore RFQ History",
  rfq_archive_successfully: "RFQ Archive Successfully",
  rfq_history_archive_successfully: "RFQ Archived Successfully",
  rfq_history_archive_successfully1: "RFQ Scraped Successfully",
  error_in_rfq_history_archive: "Error in Archive RFQ",
  error_in_rfq_history_archive1: "Error in Scraping RFQ",
  error_in_rfq_history: "Error in RFQ History",
  error_in_archive_rfq: "Error in Archive RFQ",
  error_in_rfq_list: "Error in RFQ List",
  rfq_restore_successfully: "RFQ Restore Successfully",
  error_in_restore_rfq: "Error in Restore RFQ",
  pl_archive_rfq: "Archived RFQ",
  pl_transist_insurance: "Transit Insurance",
  pl_material_delivery_pincode: "Material Delivery Pincode",
  pl_price_cap: "Enter Price Cap (₹)",
  pl_timeline_cap: "Enter Timeline Cap/ Price Validity Cap (₹)",
  pl_quntity_cap: "Quantity Cap",
  add_rfq_succesfully: "RFQ Added Successfully",
  pr_assign_to_buyer_successfully: "PR Assign to Buyer Successfully",
  assign_pr: "Assign Purchase Requisition (PR)",
  float_rfq: "Float RFQ",
  //RFQ basic detail page
  pl_rfq_basic_detail: "RFQ Basic Detail",
  pl_amount_cap: "Enter Amount Cap (₹)",
  pl_search_rfq_number: "Search Repeat RFQ Number",
  rfq_approval_sent_successfully: "Rfq Sent For Approval",
  //Rfq detail
  pl_rfq_number: "RFQ Number",
  pl_currency: "Currency",
  pl_price_basis: "Price Basis",
  pl_select_price_basis: "Select Price Basis",
  pl_freight: "Freight",
  pl_select_freight: "Select Freight",
  pl_unloading: "Unloading",
  pl_transport_insurance: "Transport Insurance",
  error_in_rfq_detail: "Error in RFQ Detail",
  rfq_detail_added_successfully: "RFQ Detail Added Successfully",
  rfq_detail_updated_successfully: "RFQ Detail Updated Successfully",
  rfq_material_added_successfully: "RFQ Material Added Successfully",
  rfq_material_updated_successfully: "RFQ Material Updated Successfully",
  error_in_add_rfq_material: "Error in Add RFQ Material",

  //Rfq Material
  pl_select_category: "Select Category",
  pl_material_name: "Material Name",
  pl_hsn: "HSN",
  val_hsn: "Please Enter HSN",
  pl_quantity: "Quantity",
  pl_enter_quantity: "Enter Quantity",
  pl_vendor: "Vendor",
  val_vendor: "Please Enter Vendor",
  val_material_name: "Please Enter Material Name",
  min_inquiry_value: "Please enter minimum inquiry value",
  max_inquiry_value: "Please enter maximum inquiry value",
  val_category: "Please Enter Category",
  val_quantity: "Please Enter Quantity",
  label_income_measurement: "Income Measurement",
  pl_income_measurement: "Select Income Measurement",
  val_income_measurement: "Enter valid Income Measurement",
  label_maximum_inquiry_value: "Maximum Inquiry Value",
  pl_maximum_inquiry_value: "Enter maximum inquiry value",
  val_maximum_inquiry_value: "Enter valid maximum inquiry value",
  //Bid Rfq
  error_in_bidding: "Error In Bidding",
  // bidding_of_R0: "Initial Bid Successfully Done",
  // bidding_of_R1: "Revised Bid Successfully Done",
  // bidding_of_R: "Final Bid Successfully Done",

  bidding_of_R0: "Initial BID Submitted",
  bidding_of_R1: "Revised BID Submitted",
  bidding_of_R: "Final BID Submitted",
  //RFQ document
  pl_documnet_name: "Document Name",

  //Material List Page
  material: "Material",
  materialMaster: "Material Master",
  pl_materialListing: "Material Listing",
  pl_material: "Material Master",
  pl_add_material: "Add Material",
  label_category_tree: "Category ",
  label_category: "Select Category",
  pl_category_tree: "Select category",
  val_category_tree: "Please select category",
  val_joining_date: "Please select Joining Date",
  label_short_description: "Short Description",
  label_erp_material: "ERP Material Code",
  pl_erp_material: "Enter ERP Material Code",
  val_erp_material: "Please Enter ERP Material Code",
  pl_short_description: "Enter Short Description",
  val_short_description: "Please enter short descriptifon",
  pl_enter_shop_no: "Enter shop no, building",
  pl_enter_area_street: "Enter area, street",
  label_long_description: "Long Description",
  pl_long_description: "Enter Long Description",
  val_long_description: "Please enter long description",
  label_code: "Smart Buyer Code",
  pl_code: "Enter Smart Buyer Code",
  val_code: "Please enter code",
  label_unit_of_measurement: "Unit of Measurement",
  pl_unit_of_measurement: "Select unit of measurement",
  pl_unit_of_measurement_enter: "Enter unit of measurement",
  val_unit_of_measurement: "Please enter unit of measurement",
  archive_unit_of_measurement: "Archived Unit Of Measurement",
  pl_add_unit_of_measurement: "Add UoM.",
  label_image: "Image Upload",
  pl_image: "Choose Image",
  val_image: "Please choose image",
  upload_image: "Browse",
  error_in_archived_material: "Error In Archived Material List",
  archived_material: "Archived Material",
  material_updated_successfully: "Material updated successfully",
  material_added_successfully: "Material added successfully",
  archive: "Archive",
  error_in_list_material: "Error in list material",
  material_archive_successfully: "Material archive successfully",
  material_archive_successfully6: "Material archived successfully",
  error_in_delete_material: "Error in delete material",
  purchase_requisition_added_successfully:
    "Purchase Requisition Sent Successfully",
  purchase_requisition_updated_successfully:
    "Purchase Requisition Updated Successfully",
  purchase_requisition_draft_successfully:
    "Purchase Requisition Draft Successfully",
  purchase_requisition_draft_updated_successfully:
    "Purchase Requisition Draft Updated Successfully",

  //unit of measurement

  error_in_unit_of_measurement: "Error in UoM.",
  unit_of_measurement_archive_successfully: "UoM. archived successfully",
  unit_of_measurement_added_successfully: "UoM. added successfully",
  unit_of_measurement_updated_successfully: "UoM. updated successfully",
  unit_of_measurement_restore_successfully: "UoM. restored successfully",
  error_in_restore_unit_of_measurement: "Error in restored UoM.",

  //Subscription
  subscriptionMaster: "Subscription Master",
  subscriptionList: "Subscription Listing",
  error_in_subscription_list: "Error in subscription list",
  archived_subscription: "Archived Subscription",
  subscription_archive_successfully: "Subscription archived successfully",
  error_in_archive_subscription: "Error in archive subscription",
  error_in_archived_subscription_list: "Error in archived subscription list",
  subscription_restore_successfully: "Subscription restore successfully",
  error_in_restore_subscription: "Error in restore subscription",

  //Purchased Subscription
  error_in_purchased_subscription_list: "Error in purchased subscription list",
  error_in_performa_invoice_list: "Error in performa invoice list",
  purchasedSubscription: "Purchased Subscription",
  purchasedSubscriptionList: "Purchased Subscription Listing",
  archived_purchased_subscription: "Archived Purchased Subscription",
  label_payment_mode: "Payment Mode",
  pl_payment_mode: "Select Payment Mode",
  label_paymentRefId: "Payment RefID",
  pl_paymentRefId: "Select Payment RefID",
  val_subscription_type: "Please Enter Subscription Type",
  val_duration: "Please Enter Duration",
  val_per_user_price: "Please Enter Per User Price",
  val_payment_mode: "Please Enter Payment Mode",
  val_start_date: "Please Enter Start Date",
  val_end_date: "Please Enter End Date",
  pl_select_company: "Select Client",
  pl_select_subscription: "Select Subscription",
  pl_enter_duration: "Enter Duration",
  pl_enter_per_user_price: "Enter User Price (INR)",
  pl_zero_discount: "0",
  pl_enter_sell_price: "Enter Sell Price",
  pl_select_payment_mode: "Select Payment Mode",
  pl_start_date: "11-08-2023",
  pl_end_date: "11-09-2023",
  val_sell_price: "Please Enter Sell Price",
  error_in_archived_purchase_subscription:
    "Error in Archived Purchase Subscription",
  purchased_subscription_restore_successfully:
    "Purchased Subscription Restore Successfully",
  error_in_restore_purchased_subscription:
    "Error in Restore Purchase Subscription",

  //Company Onboarding
  error_in_company_onboarding_list: "Error in client onboarding",
  company_onboarding_archive_successfully:
    "Client onboarding archive successfully",
  company_onboarding_archive_successfully1: "Client archived successfully",
  error_in_archive_company_onboarding: "Error in archive client onboarding",
  companyOnboarding: "Company Onboarding",
  addCompany: "Add Company",
  archived_company_onboarding: "Archived Company Onboarding",
  company_onboarding_restore_successfully:
    "Company onboarding restore successfully",
  company_onboarding_restore_successfully1: "Company restored successfully",
  error_in_restore_company_onboarding: "Error in restore company onboarding",
  addCompanyOnboarding: "Add Company Onboarding",
  label_company_name: "Company Name",
  label_company_name1: "Company Legal Name",
  pl_company_name1: "Enter Company Legal Name",
  val_company_name1: "Enter valid Name",
  pl_company_name: "Enter company name",
  val_company_name: "Please enter company name",
  label_person_name: "Person Name",
  pl_person_name: "Enter person name",
  val_person_name: "Please enter person name",
  label_address_line_1: "Address Line 1",
  val_address_line_1: "Please enter address",
  val_WBS_number: "Please Enter WBS Number",
  image_aadhar_deleted_success: "Addharcard deleted successfully",
  image_pan_deleted_success: "Pancard deleted successfully",
  image_gst_deleted_success: "Gst document deleted successfully",
  payment_released_updated_successfully:
    "Payment released contact updated successfully",
  payment_released_added_successfully:
    "Payment released contact added successfully",
  label_address_line_2: "Address Line 2",
  label_site_short_name: "Site Name",
  pl_site_short_name: "Enter Site Name",
  val_site_short_name: "Please enter site short name",
  val_address_line_2: "Please Enter Address Line 2",
  val_pincode_select: "Please select valid pin code",
  label_no_of_employee: "No. Of Employee",
  label_company_pan1: "Company PAN Number",
  pl_no_of_employee: "0 to 10",
  pl_back_to_list: "Back To List",
  val_no_of_employee: "Please enter no. of employee",
  label_assign_site_to_vendor: "Assign Site To Vendor",
  pl_assign_site_to_vendor: "select sites",
  val_assign_site_to_vendor: "Please select sites",
  label_cin_number: "CIN Number",

  pl_cin_number: "Please enter CIN number",

  val_cin_number: "Please enter valid CIN number",
  label_client_pan: "PAN Number",
  pl_client_pan: "Enter PAN number",
  label_company_pan: "PAN Number",
  pl_company_pan: "Enter PAN number",
  val_company_pan: "Enter PAN number",
  label_gst_no: "Please enter GST number",
  pl_gst_no: "Enter GST number",
  place_gst_no: "Enter GST number",
  place_gst_no5: "GST Number",
  val_gst_no: "Enter valid GST Number",
  val_about_company: "Please enter about client",
  keyperson: "Key Person",
  company_added_successfully: "Client added successfully",
  company_updated_successfully: "Client updated successfully",
  error_in_add_company: "Error in add client",
  please_enter_valid_phone: "Please enter valid phone",
  archived_company_document: "Archived Company Documents",
  error_in_restore_document: "Error in restore document",
  document_restore_successfully: "Document restore successfully",
  error_in_document_archive: "Error in document archive",
  document_archive_successfully: "Document archive successfully",
  //Vendor Onboarding
  vendor_communication_detail_updated:
    "Vendor communication detail updated successfully",
  vendor_communication_detail_added:
    "Vendor communication detail added successfully",
  vendorOnboarding: "Vendor Onboarding",
  addRFQBreadcrumb: "RFQ",
  pl_enter_vendor_code: "Enter vendor code",
  pl_vendor_code: "Vendor Code",
  addVendor: "Add Vendor",
  addVendorOnboarding: "Add Vendor Onboarding",
  verifyEmail:
    "RFQ - Verify Emails For Notifications at different stages(eg. Inquiry / Offer / Order)",
  verifyEmailBreadcrumb: "Verify Emails For Notifications",
  label_vendor_company_name: "Legal Name Of The Vendor",
  rfq_email_person_name: "Person Name",
  pl_vendor_company_name: "Enter legal name of the vendor",
  pl_email_person_name: "Enter Person Name",
  val_vendor_company_name: "Please enter Legal Name Of The Vendor",
  error_in_vendor_onboarding_list: "Error in vendor onboarding list",
  label_account_holder_name: "Account Holder Name",
  pl_account_holder_name: "Enter account holder name",
  val_account_holder_name: "Please enter account holder name",
  label_account_number: "Account Number",
  pl_account_number: "Enter account number",
  val_account_number: "Please enter account number",
  label_bank_name: "Bank Name",
  pl_bank_name: "Enter bank name",
  val_bank_name: "Please enter bank name",
  label_branch_name: "Branch Name",
  pl_branch_name: "Enter branch name",
  val_branch_name: "Please enter branch name",
  label_ifsc_code: "IFSC Code",
  pl_ifsc_code: "Enter IFSC code",
  val_ifsc_code: "Please enter IFSC code",
  vendor_onboarding_archive_successfully:
    "Vendor onboarding archive successfully",
  error_in_archive_vendor_onboarding: "Error in archive vendor onboarding",
  vendor_onboarding_restore_successfully:
    "Vendor onboarding restore successfully",
  error_in_restore_vendor_onboarding: "Error in restore vendor onboarding",
  archived_vendor_onboarding: "Archived Vendor Onboarding",
  vendor_added_successfully: "Vendor added successfully",
  please_enter_inquiry_value: "Please Enter Inquiry Value",
  vendor_updated_successfully: "Vendor updated successfully",
  document_added_successfully: "Document added successfully",
  document_updated_successfully: "Document updated successfully",
  archived_vendor_document: "Archived Vendor Document",
  error_in_adding_vendor: "Error in Adding Vendor",
  error_in_updating_vendor: "Error in Updating Vendor",
  bankDetails: "Bank Details",
  label_minimum_inquiry_value: "Minimum Inquiry Value",
  pl_minimum_inquiry_value: "Enter minimum inquiry value",
  value_minimum_inquiry_value: "Enter valid inquiry value",
  label_lut_number: "LUT Number",
  pl_lut_number: "Enter LUT number",
  val_lut_number: "Enter valid LUT Number",
  label_msme: "MSME",
  pl_msme_number: "MSME Number",
  pl_enter_msme_number: "UDYAM-XX-00-0000000",
  val_msme_number: "Enter valid msme number",
  pl_msme_document_upload: "MSME Document Upload",
  label_days_to_pay: "Days To Pay",
  pl_days_to_pay: "Select days to pay",
  pl_when_to_pay: "Select when to pay",
  pl_when_to_calculate: "Select when to calculate from",
  pl_advance: "Enter advance (%)",
  label_when_to_pay: "When To Pay",
  label_when_to_calculate: "From When To Calculate",
  label_advance: "Advance in %",
  pl_payment_security_type: "Select payment security type",
  val_days_to_pay: "Please Select Days To Pay",
  val_when_to_pay: "Please Select When To Pay",
  val_when_to_calculate: "Please Select When To Calculate",
  val_advance: "Please Enter Advance",
  val_payment_security_type: "Please Select Payment Security Type",
  pl_bank_garrentee_value: "Bank Guarantee Value",
  val_bank_garrentee_value: "Please enter valid value",
  pl_bank_guarantee_supply_limit_value: "Supply Limit Value",
  val_bank_guarantee_supply_limit_value: "Please enter valid limit",
  pl_bank_garrentee_open_date: "Open Date",
  pl_bank_garrentee_validity_complation_date: "Validity Completion Date",
  pl_lc_value: "LC Value",
  val_lc_value: "Please enter valid value",
  pl_lc_supply_limit_value: "Supply Limit Value",
  val_lc_supply_limit_value: "Please enter valid limit",
  pl_lc_open_date: "Open Date ",
  pl_lc_validity_complation_date: "Validity Completion Date",
  editCompanyOnboarding: "Edit Company Onboarding",
  editVendorOnboarding: "Edit Vendor Onboarding",
  payment_terms_updated_successfully: "Payment term updated successfully",
  payment_terms_added_successfully: "Payment term added successfully",
  assignsite_added_successfully: "Assign Site Added Successfully",
  assignsite_updated_successfully: "Assign Site Updated Successfully",
  archived_assign_site: "Archived Assign Site",
  assign_site_archive_successfully: "Assign Site Archived Successfully",
  error_in_assign_site_archive: "Error in Assign Site Archive",
  assign_site_restore_successfully: "Assign Site Restore Successfully",
  error_in_restore_assign_site: "Error in Assign Site Restore",

  //PRApprovalHierarchy
  error_in_list_prapproval_hierarchy: "Error in pr approval hierarchy list",
  error_in_archive_prapproval_hierarchy:
    "Error in archive pr approval hierarchy",
  Error_in_site: "Error in Site",
  pr_approval_hierarchy_updated_successfully:
    "PR approval hierarchy updated successfully",
  pr_approval_hierarchy_added_successfully:
    "PR approval hierarchy added successfully",
  error_in_release_manager: "Error in release manager",
  error_in_prapproval_hierarchy: "Error in pr approval hierarchy",
  prapproval_hierarchy_archive_successfully:
    "PR approval hierarchy archive successfully",
  prapproval_hierarchy_restore_successfully:
    "PR approval restored successfully",
  error_in_restore_prapproval_hierarchy:
    "Error in restore pr approval hierarchy",
  lbl_pr_release_hierarchy: "PR Release Hierarchy",

  please_enter_value_upto: "Please enter value",
  please_select_release_manager: "Please select release manager",
  bankdetail_updated_successfully: "Bank detail updated successfully",
  bankdetail_added_successfully: "Bank detail added successfully",
  keyperson_updated_successfully: "Keyperson updated successfully",
  keyperson_added_successfully: "Keyperson added successfully",
  inquiryvalue_updated_successfully: "Inquiry value updated successfully",
  //commercial invoice

  commercialInvoiceList: "Commercial Invoice List",
  addCommercialInvoice: "Add Commercial Invoice",

  //performa invoice

  performaInvoiceList: "Performa Invoice List",
  addPerformaInvoice: "Add Performa Invoice",
  val_invoice_number: "Please enter valid invoice number",
  label_invoice_number: "Invoice Number",
  pl_invoice_number: "Invoice Number",
  pl_billed_by: "Billed By",
  pl_billed_to: "Billed To",
  val_subscription_package: "Please enter valid subscription package",
  subscription_package: "Subscription Package",
  val_gst_number: "Please enter valid GST number",
  pl_subscription_package: "Please enter subscription package",
  archived_category6: "Archived Category",
  archived_subcategory6: "Archived Sub Category",
  pl_archived_material_type_list6: "Archived Material Type",
  save_as_draft: "Save As Draft",
  val_note: "Please enter Note",
  pl_enter_amount: "Please enter amount",
  val_amount: "Please enter valid amount",
  pl_amount: "Amount",
  pl_enter_gst_number: " Enter GST number",
  pl_rate: "Please enter GST rate",
  val_rate: "Please enter valid gst rate",
  pl_gst_number: "GST Number",
  pl_note: "Note",
  pl_select_client: "Select Client",
  invoice_added_successfully: "Invoice Added Successfully",
  invoice_updated_successfully: "Invoice Updated Successfully",
  addInvoice: "Add Invoice",
  pl_select_caterory: "Select Caterory",
  //confirmmessage
  label_Address: "Flat, House no., Building, Company, Apratment",
  label_area: "Area, Street, Sector, Village",
  pl_sub_category_example: "Example General Cement, Special Cement, RMC",

  label_landmark: "Landmark",
  lbl_city: "Town/City",
  confirmAlert_title: "Confirm to update status ?",
  confirmAlert_message: "Are you sure to do this ?",
  confirmAlert_ok: "Yes",
  confirmAlert_cancel: "Cancel",
  pl_contact_person_name: "Contact Person Name",
  val_contact_person_name: "Please Enter Contact Person Name",
  pl_enter_contact_person_name: "Enter Contact Person Name",
  place_enter_contact_person_name: "Enter contact person name",

  //MaterialTypeList page
  error_in_material_type: "Error in Material Type",
  material_type_archive_successfully: "Material type archive successfully",
  material_type_archive_successfully6: "Material type archived successfully",
  pl_material_type: "Select material type",
  pl_material_type4: "Material type",

  pl_add_material_type: "Add Material Type",
  pl_select_material_type: "Select Material Type",
  pl_enter_valid_date: "Enter valid date",
  pl_hsn_code: "HSN CODE",
  pl_enter_hsn_code: "Enter HSN Code",
  val_hsn_code: "Please enter valid HSN code",
  error_in_add_material_code: "Error in material code",
  material_code_updated_successfully: "Material Code Updated Successfully",
  material_code_added_successfully: "Material Code Added Successfully",
  //Archived Material Type List page
  pl_archived_material_list: "archived material list",
  pl_archived_material_type_list: "Archived material type",
  material_type_restore_successfully: "Material type restored successfully",
  error_in_restore_material_type: "Error in restore material type",

  //Add MaterialTypeList page
  pl_enter_type: "Enter material type",
  error_in_adding_material_type: "Error in adding material type",
  error_in_updating_material_type: "Error in updating material type",
  material_type_added_successfully: "Material type added successfully",
  material_type_updated_successfully: "Material type updated successfully",
  error_in_add_material: "Error in add material",
  material_restore_successfully: "Material restore successfully",
  material_restore_successfully6: "Material restored successfully",
  error_in_restore_material: "Error in restore material",
  label_gst: "GST (%) on Cement",
  label_gst1: "GST (%) on Material",
  label_gst2: "GST (%)",
  label_gst_freight: "GST (%) on Freight",
  pl_gst: "Enter GST",
  pl_gst_freight: "Enter GST For Freight",
  label_estimated_unit_price: "Estimated Unit Price",
  pl_estimated_unit_price: "Enter unit price",
  val_estimated_unit_price: "Enter valid unit price",
  label_escalation: "Escalation (%)",
  pl_escalation: "Enter escalation",
  pl_sub_category: "Sub Category",
  val_category_wise_WBS_number: "Please Enter WBS Number",
  pl_gst5: "Please enter GST",

  // PlaceHolders / Lables

  pl_company: "Client",
  company_name_requesteddemo: "Company",
  pl_demo_date: "Demo Date",
  pl_demo_date_time: "Demo Date & Time",
  pl_companyName: "Company Name",
  pl_typeCompanyName: "Company Name Type Here",
  pl_mfg_facility_location: "Mfg. Facility Location",
  place_personName: "Enter person name",
  pl_personName: "Person Name",
  pl_personName1: "Enter person name",
  pl_name: "Client Personnel",
  pl_requested_name: "Name",
  pl_designation_name: "Functional Designation",
  pl_ContactNo: "Contact Number",
  pl_designation: "Enter designation",
  pl_designation1: "Enter Designation",
  lbb_designation: "Designation",
  place_designation: "Enter designation",
  pl_password: "Password",
  pl_current_password: "Current Password",
  pl_newpassword: "New Password",
  pl_confirm_password: "Confirm Password",
  pl_email: "Enter email",
  lbb_email: "Email",

  // lbb_email: "Enter Email",
  place_email: "Enter your email",
  pl_email1: "Enter your registered email",
  pl_personalEmail: "Official Email",
  pl_personMobile: "Contact / Mobile Number",
  pl_msg: "Message",
  pl_country: "Country",
  pl_chooseCountry: "Choose Country",
  pl_state: "State",
  place_state: "Select your state",
  pl_city: "Town/City",
  place_city: "Select your city",
  pl_landmark: "Landmark",
  pl_website: "Website",
  place_website: "Enter your website",
  pl_corporateAddress: "Corporate Address",
  pl_addressLine1: "Address Line 1",
  pl_addressLine2: "Address Line 2",
  pl_headOffice_email: "Head Office Email",
  pl_headOffice_contactNo: "Head Office Contact Number",
  pl_company_RegistrationNo: "Company Registration No",
  pl_company_establishedDate: "Company Establishment date",
  pl_gstNo: "GSTN",
  pl_manufacturing_fromCountry: "Manufacturing from country",
  pl_supplying_toCountries: "Supplying to Countries",
  pl_how_did_you_hear_about_us: "How did you hear about us",
  pl_facility_email: "Facility Email",
  pl_facility_contact_number: "Facility Contact Number",
  pl_address_line_1: "Enter your address",
  pl_address_line_2: "Enter your address",
  upload_fileType: "(.jpg,.png,.pdf,.ppt,.docx)",
  upload_imagefileType: "(.jpg, .png)",
  upload_imagefileType_company: "(.jpg, .png, .pdf)",

  pl_no_of_manufacturing_facilities: "No. Of Manufacturing Facilities",
  pl_manufacturing_country: "Manufacturing From Country",
  pl_supplying_country: "Supplying To Countries",
  pl_video_url: "Video Link Url",
  pl_about_company: "About Client",
  place_about_company: "Enter about client",
  pl_about_vendor: "About Vendor",
  pl_other_payment_type: "Other Payment Security Type",
  pl_enter_payment_type: "Enter Other Payment Type",
  pl_enter_about_vendor: "Enter About Vendor",
  val_about_vendor: "Please Enter About Vendor",
  pl_about_me: "About Me",
  pl_user_name: "User Name",
  pl_first_name: "First Name",
  pl_last_name: "Last Name",
  pl_search: "search",
  pl_facility_location: "Facality Location",

  pl_company_email: "Company Email",
  pl_user_role: "User Role",
  pl_message: "Message",
  pl_reply_to: "Reply To",
  pl_reason_contacting_support_lable: "Reason For Contacting Support",
  pl_reason_contacting_support: "Why Are You Contacting Support?",
  pl_how_help: "How Can We Help You",

  label_package_name: "Package Name",
  val_package_name: "Please Enter Package Name",
  pl_subscription_type: "Subscription Type",
  pl_per_user_price: "Per User Price (INR)",
  pl_purchase_requistions: "Purchase Requistions",
  pl_label_start_date: "Start Date",
  pl_label_end_date: "End Date",

  pl_concierge_type: "Concierge Type",
  pl_package_type: "Package Type",
  pl_actual_price: "Actual Price (INR)",
  pl_discount: "Discount (%)",
  pl_sell_price: "Sell Price (INR)",
  pl_duration: "Duration (days)",
  pl_description_subscription: "Description",

  pl_login_with_email: "youremail@gmail.com",
  pl_login_with_mobile: "+91 Mobile Number",
  pl_get_otp: "Get OTP",
  didnotreceived: "Didn't Received?",

  // ForgotPassword
  pl_forgot_password_label1:
    "Enter your registered email address and we will send you a link to reset your password",
  pl_enter_email_or_mobile_number: "Enter Email OR Mobile Number",

  //ResetPassword
  pl_new_password_label1:
    "Your new password must be different from previously used password",
  pl_enter_new_password: "Enter new password",
  pl_confirm_your_password: "Confirm your password",
  pl_reset_password: "Reset Password",
  val_select_role: "Please Add A Role And Permission",
  pl_log_out_pop_up_msg: "Are you sure you want to log out?",
  //RequestedDemoList
  pl_requested_demo: "Demo Request",
  pl_enter_your_name: "Enter your name",
  pl_enter_your_designation: "Enter Your Designation",
  pl_enter_your_company_name: "Enter your company name",
  pl_mobile_number: "Mobile Number",
  pl_enter_your_mobile_number: "Enter your mobile number",
  pl_e_mail: "Email",
  pl_enter_your_email: "Enter your email",
  pl_number_of_buyers: "Buyer Count",
  pl_num_of_buyers: "Number Of Buyer",
  pl_upload_gst: "Upload GST Document",
  pl_enter_number_of_buyers: "Enter number of buyers",
  pl_enter_about_your_company: "Enter about your company",
  pl_enter_your_message: "Enter Your Message",
  pl_active: "Active",
  pl_save_changes: "Save Changes",
  pl_remark: "Remark",
  place_remark: "Your remarks or suggestions",
  pl_enter_about_your_company_profile: "Enter client profile",
  pl_about_company_profile: "Client Profile",
  pl_about_company_requesteddemo: "About Company",
  pl_enter_about_your_company_requesteddemo: "Enter about your company",

  //Setting page
  pl_shipping_address: "Shipping Address",
  pl_billing_address: "Billing Address",
  pl_select_currency: "Select Currency",
  error_in_settings: "Error in settings",
  settings_updated_successfully: "Settings updated successfully",
  error_in_business_setting: "Error in business setting",
  business_setting_added_successfully: "Business setting added successfully",
  business_setting_updated_successfully:
    "Business setting updated successfully",
  pl_rfq_second_value_up_to: "Please enter value",
  pl_select_rfq_second_release_manager:
    "Please select RFQ second release manager",
  pl_rfq_third_value_up_to: "Please enter value",
  pl_select_rfq_third_release_manager:
    "Please select rfq third release manager",
  pl_rfq_forth_value_up_to: "Please enter value",
  pl_select_rfq_forth_release_manager:
    "Please select rfq forth release manager",
  pl_rfq_fifth_value_up_to: "Please enter value",
  pl_select_rfq_fifth_release_manager:
    "Please select rfq fifth release manager",
  pl_approval_second_value_up_to: "Please enter value",
  pl_select_approval_second_release_manager:
    "Please select approval second release manager",
  pl_approval_third_value_up_to: "Please enter value",
  pl_select_approval_third_release_manager:
    "Please select approval third release manager",
  pl_approval_forth_value_up_to: "Please enter value",
  pl_select_approval_forth_release_manager:
    "Please select approval forth release manager",
  pl_approval_fifth_value_up_to: "Please enter value",
  pl_select_approval_fifth_release_manager:
    "Please select approval fifth release manager",
  pl_purchase_order_second_value_up_to: "Please enter value",
  pl_select_purchase_order_second_release_manager:
    "Please select po second release manager",
  pl_purchase_order_third_value_up_to: "Please enter value",
  pl_select_purchase_order_third_release_manager:
    "Please select po third release manager",
  pl_purchase_order_forth_value_up_to: "Please enter value",
  pl_select_purchase_order_forth_release_manager:
    "Please select po forth release manager",
  pl_purchase_order_fifth_value_up_to: "Please enter value",
  pl_select_purchase_order_fifth_release_manager:
    "Please select po fifth release manager",

  //Add Employee
  label_employeeId: "Employee ID",
  pl_employeeId: "Enter your id",
  val_employeeId: "Please enter your employee id",
  label_firstName: "First Name",
  pl_firstName: "Enter your first name",
  label_lastName: "Last Name",
  pl_lastName: "Enter your last name",
  label_email: "Email",
  pl_email_2: "Enter vendor's email",
  pl_email_3: "Enter your email",
  add_employee: "Add Employee",
  label_mobileNumber: "Mobile Number",
  label_phoneNumber: "Contact Number",
  pl_contact_num: "Enter your contact number",
  val_contact_num: "Please enter valid contact number",

  pl_mobileNumber: "Enter your mobile number",
  val_mobileNumber: "Please enter valid mobile number",
  label_designation: "Designation",
  label_resignation: "Resignation Date",
  label_reliving: "Reliving Date",
  pl_designation_2: "Enter your designation",
  pl_emergency_contact: "Enter emergency contact number",
  pl_resignation: "Enter resignation date",
  pl_reliving: "Enter reliving date",
  val_designation_2: "Please enter valid designation",
  label_role: "Role",
  pl_role: "Enter number of buyer",
  val_role: "Please select valid number of buyer",
  pl_site_name_select: "Select site name",
  label_adharcard: "Aadhar Number",
  pl_adharcard: "987487454784",
  val_adharcard: "Please enter valid aadhar number",
  label_pancard: "PAN Number",
  pl_pancard: "EYYOP4012K",
  val_pancard: "Please enter valid PAN number",
  label_emergencyContact: "Emergency Contact",
  pl_emergencyContact: "Enter Number",
  val_emergencyContact: "Please enter valid number",
  label_currentAddress: "Current Address",
  pl_address: "Enter your address",
  val_address: "Please enter valid address",
  label_permanentAddress: "Permanent Address",
  label_status: "Status",
  val_status: "Please choose valid status",
  pl_employee: "Employee",
  employee_added_successfully: "Employee added successfully",
  employee_updated_successfully: "Employee updated successfully",
  error_in_list_employee: "Error in list employee",
  employee_restore_successfully: "Employee restore successfully",
  error_in_restore_employee: "Error in restore employee",
  employee_archive_successfully: "Employee archive successfully",
  error_in_delete_employee: "Error in delete employee",
  label_pr_value_limit: "PR Value Limit (₹)",
  pl_pr_value_limit: "Enter PR value limit",
  val_pr_value_limit: "Please enter PR value limit",
  //Pincode
  pl_pincode: "Pin Code",
  pl_pincodeselect: "Select pin code",
  pl_enter_pincode: "Enter pin code",
  pl_zone: "Zone",
  val_zone: "Select zone",
  pl_edit_zone: "Edit zone",
  pl_select_zone: "Select Zone",
  pincode_archive_successfully: "Pin code archived successfully",
  error_in_delete_pincode: "Error in delete pin code",
  pincode_added_successfully: "Pin code added successfully",
  pincode_updated_successfully: "Pin code updated successfully",
  error_in_adding_pincode: "Error in adding pin code",
  error_in_updating_pincode: "Error in updating pin code",
  pincode_restore_successfully: "Pin code restored successfully",
  error_in_restore_pincode: "Error in restored pin code",
  sample_file: "Sample File",

  follow_up_added_successfully: "Follow Up Date Added",
  follow_up_updated_successfully: "Follow Up Date Updated",

  //login Page
  pl_email_or_mobile: "Email or Mobile",
  pl_enter_your_email_or_mobile_email: "Enter your registered email or mobile",
  pl_enter_your_password: "Please enter your password",
  pl_forgot_password: "Forgot Password ?",

  // AddZoneModel page
  pl_zone_name: "Zone Name",
  pl_archive: "Archive",
  pl_search_list: "Search List",
  pl_add_zone: "Add Zone",
  msg_pleaseUploadFile: "Please Upload File",
  pl_archive1: "Archived",

  //Employee List
  employeeList: "Employee",
  error_in_employee_list: "Error in employee list",
  pl_employeeListing: "Employee Listing",
  pl_add_employee: "Add Employee",
  error_in_updating_employee: "Error in updating employee",
  error_in_adding_employee: "Error in adding employee",
  pending: "Pending",
  active: "Active",
  inactive: "Inactive",
  archived_employee_list: "Archived Employee List",
  // Requested demo list page
  pl_add_request_demo: " Add Request Demo",
  pl_demo_requested: "Demo Request Cockpit",
  pl_demo_request: "Demo Request",

  //Archive list page

  pl_Archive: " Archive",
  pl_archived_demo_request: "Archived Demo Request",
  pl_restore: "Restore",
  requested_demo_restore_successfully: "Requested Demo Restored Successfully",
  error_in_restore_requested_demo: "Error in Restore Requested Demo List",

  //AddAddress page
  error_in_list_delivery_address: "Error in list of site location",
  delivery_address_added_successfully: "Site location added successfully",
  delivery_address_updated_successfully: "Site location updated successfully",
  pl_site_location: "Site Location",
  pl_site_location_list: "Site Location List",
  pl_add_address: "Add Site Location",
  pl_address_label: "Address Master",
  pl_enter_company_name: "Enter company legal name",
  val_select_company_name: "Please enter company name",
  val_company_name1: "Please enter valid legal name",
  pl_enter_site: "Enter site name",
  pl_address1: "Address",
  val_site: "Please Enter Site Name",
  pl_state_province: "State/Province",
  pl_postal_zip_code: "Postal / Zip Code",
  pl_land_mark: "Land Mark",
  place_land_mark: "Enter landmark",
  place_landmark: "Enter landmark",
  pl_street_address_line_1: "Street Address Line 1",
  pl_street_address: "Enter street address",
  pl_phone_or_whatsapp_number: "Phone or WhatsApp Number",
  pl_phone: "Contact Number",
  pl_phone_alternate: "Alternate Contact Number",
  pl_emailname: "Email",
  pl_enter_email: "Enter Email",
  place_enter_email: "Enter email",
  pl_address_type: "Address Type",
  site_location_updated_successfully: "Site location updated successfully",
  site_location_added_successfully: "Site location added successfully",

  // PurchaseReuisition
  pl_purchase_requisition: "Purchase Requisition",
  pl_purchase_requisition_list: "Purchase Requisition List",
  pl_add_purchase_requisition: "Add Purchase Requisition",
  enter_quantity: "Enter Quantity",
  enter_amount: "Enter Amount",
  label_site: "Site",
  val_site_name: "Please Enter Site Name",
  archived_purchase_requisition: "Archived Purchase Requisition (PR)",

  // Activity Log page
  pl_activity_log: "Activity Log",
  pl_archive_activity_log: "Archived Activity Log",
  error_in_activity_log_list: "Error in Activity Log List",
  activity_log_archive_successfully: "Activity Log Archive Successfully",
  error_in_archive_activity_log: "Error in Archive Activity Log",
  activity_log_restore_successfully: "Activity Log Restore Successfully",
  error_in_restore_activity_log: "Error in Restore Activity Log",

  //Hierarchy page
  label_hierarchy: "Enter Hierarchy Name",
  pl_rfq_approval: "RFQ Approval",
  pl_applicable_on: "Applicable On",
  pl_select_employee: "Select Employee",
  val_select_employee: "Please Select Employee",
  purchase_requisition_delete_successfully:
    "Purchase Requisition Deleted Successfully",
  pop_delete_title: "Are you sure you want to delete permanently ?",
  email_notified: "Email notified",
  error_in_delete_purchase_requisition_history:
    "Error in Deleting Purchase Requisition",
  val_sequence: "Please Enter Sequence",
  pl_sequence: "Sequence",
  pl_hierarchy: "Hierarchy",

  //ArchiveDelivery List
  pl_archive_delivery: "Archived Site Location",

  //company documents
  pl_company_documents: " Client Documents",
  pl_add_documents: "Add Documents",

  //ArchiveCompanyDocuments
  pl_archive_company_documents: "Archived Client Documents",

  //Add Documents
  pl_document_name: "File Name",
  place_upload_document: "Upload document",
  pl_enter_document_name: "Enter document name",
  pl_upload_document: "Upload Document",
  pl_upload_aadhar: "Upload Aadhar Document",
  pl_upload_pan: "Upload PAN Document",
  pl_choose_document: "Choose document",
  //Roles List
  pl_roles: "Role",
  pl_role_listing: "Role Listing",
  pl_add_role: "Add Role",

  // AddRole
  pl_permission: "Permission",

  //AddNewPurchaseRequesitition
  favourite_added_successfully: "Favourite Added Successfully",
  favourite_updated_successfully: "Favourite Updated Successfully",

  error_in_purchase_requisition: "Error in Purchase Requisition",

  purchase_requisition_history_restore_successfully:
    "Purchase Requisition Restored Successfully",
  error_in_restore_purchase_requisition_history:
    "Error in Restore Purchase Requisition History",

  purchase_requisition_history_archive_successfully:
    "Purchase Requisition History Archive Successfully",
  purchase_requisition_history_archive_successfully1:
    "Purchase Requisition Archived Successfully",
  // Value msg
  bidders: "Bidder(s)",
  val_name: "Please enter name",
  val_designation1: "Please enter correct designation",
  val__name: "Please enter valid name",
  val_personName: "Please enter person name",
  val_companyName: "Please enter client name",
  val_phone: "Please enter valid phone",
  val_phone1: "Please enter valid registered phone number",
  val_city: "Please enter city",
  val_city1: "Please select city",
  val_landmark: "Please enter landmark",
  pop_delete: "Are you sure to delete?",
  pop_title: "Are you sure to archive?",
  pop_title11: "Are you sure to Scrap this RFQ?",

  pop_restore_title: "Are you sure to restore ?",
  pop_photoTitle: "Are you sure archive this image ?",
  val_emergency_contact: "Please enter emergency contact number",
  val_designation: "Please enter designation",
  val_password: "Please enter password",
  val_confirm_password: "Please enter confirm password",
  val_email: "Please enter valid email",
  val_email1: "Please enter valid registered email!",

  val_terms_and_conditions: "Please accept terms and conditions",
  val_registrationNo: "Please enter valid registration no!",
  val_mfg_facility_location: "Please enter mfg. facility location",
  val_facility_location: "Please select facility location",
  val_msg: "Please enter message",
  val_company: "Please select client",
  val_country: "Please select country",
  val_state: "Please enter state",
  val_pincode: "Please enter valid pin code",
  val_website: "Please enter valid URL",
  val_corporateAddress: "Please enter corporate address",
  val_addressLine: "Please enter valid address",
  val_addressLine1: "Please enter address line 1",
  val_addressLine2: "Address Line 2",
  val_gstNo: "Please enter valid GST number",
  val_company_RegistrationNo: "Please enter client registration No",
  val_no_of_manufacturing_facilities:
    "Please enter No. of manufacturing facilities",
  val_manufacturing_country: "Please select manufacturing from country",
  val_supplying_country: "Please select supplying to Countries",
  val_video_url: "Please enter valid url",
  val_number: "Please enter valid number",
  val_about_me: "Please enter about me",

  val_reply_to: "Please enter reply to",
  val_how_help: "Please describe your question or issue in detail",
  val_reason_contacting_support: "Please enter reason for contacting support",
  val_user_role: "Please Select User Role",
  val_document_name: "Please enter document name",
  val_zone_name: "Plase enter valid zone name",
  val_description: "Please enter description",
  val_material_type: "Please enter material type",
  val_sub_category: "Please enter sub category",

  val_escalation: "Please enter escalation",

  val_select_material_type: "Please select material type",

  //Login Page
  val_enter_email_or_mobile: "Enter Email or Mobile",
  val_please_enter_your_password: "Please Enter your Password",

  //AddAddress
  val_please_enter_address: "Please enter area, street",
  val_please_enter_shop_address: "Please enter shop no, building",
  val_address1: "Please Enter Address Line 1",
  val_state_province: "Please enter state",
  val_state1: "Please select state",
  val_postal_zip_code: "Please enter pin code",
  val_postal_zip_code1: "Please enter postal/zip code",
  val_postal_open_date: "Please Select Open Date",
  val_postal_validity_complation: "Please Select Validity Complation Date",
  val_please_enter_land_mark: "Please enter landmark",
  val_address_type: "Please Enter Address Type",

  assign_pr_archive_successfully: "Assign PR Archive Successfully",
  error_in_archive_assign_pr: "Error in Archive Assign PR",
  pl_archive_float_rfq: "Archive Assign Purchase Requisition",
  assign_purchase_requisition_restore_successfully:
    "Assign Purchase Requisition Restore Successfully",
  error_in_restore_assign_purchase_requisition:
    "Error in Restore Assign Purchase Requisition",
  error_in_archive_assign_purchase_requisition:
    "Error in Archive Assign Purchase Requisition",
  sector_name_added_successfully: "Sector name added successfully",
  sector_name_updated_successfully: "Sector name updated successfully",
  error_in_adding_sector_name: "Error in adding sector name",
  error_in_updating_sector_name: "Error in updating sector name",

  place_material_type: "Material Type",
  label_place_remark: "Remark",
  pl_enter_communication_remark: "Enter communication detail",

  // Sector Page
  sector_name: "Sector Name",
  enter_sector_name: "Enter sector name",
  pl_enter_sector_name: "Please enter sector name",
  pl_search_document: "Search document",
  sector: "Sector",
  pl_add_sector: "Add Sector",
  sector_archive_successfully: "Sector name archive successfully",
  sector_archive_successfully1: "Sector archived successfully",
  error_in_archive_sector_name: "Error in archive sector name",
  error_in_sector_name: "Error in sector name",
  sector_restore_successfully: "Sector name restore successfully",
  sector_restore_successfully2: "Sector restored successfully",
  error_in_restore_sector: "Error in restore sector name",
  archived_sector_list: "Archived sectors",
  //requesteddemo list page
  val_number_of_buyers: "Please enter number of buyers",

  // setting page
  val_enter_address: "Please Enter Address",

  // Length msg

  minlength_msg: "value must be minimum 2 characters",
  maxlength_personName: "value must be maximum 20 characters",
  maxlength_designation: "value must be maximum 20 characters",
  maxlength_designation1: "value must be maximum 30 characters",
  maxlength_msg: "value must be maximum",
  characters: " characters",
  fileSize5MB: "Upload PPT / PDF - Maximum file size: 2 MB",
  photoGalleryCondition: "Upload JPG/PNG  - Maximum 5 photos limit",

  // Notifications msg

  msg_login_successfull: "Login Successfully",
  msg_PasswordChangeSuccess: "Password Changed Successfully",
  err_EnterCorrectPassword: "Please Enter Correct Password",
  already_activated: "Your account is already activated!",
  msg_userUpdateSuccess: "User updated successfully",
  err_editProfile: "Error in edit profile",
  addUser_successfull: "User Created!",
  update_active_successfull:
    "User Activated Successfully and Credential detail emailed to User.",
  update_inactive_successfull: "User Deactivated and email sent",

  company_active_successfull:
    "Company Activated Successfully and Credential detail emailed to Company.",
  company_inactive_successfull: "Company Deactivated!",
  updatedCompanyDetailSuccessful: "Company Detail Updated successfully",
  companyDeleted: "Company deleted successfully",

  msg_addSubscriptionSuccess: "Subscription added successfully",
  msg_updateSubscriptionSuccess: "Subscription updated successfully",
  err_getSubscription: "Error in get subscription details",

  msg_addPurchasedSubscriptionSuccess:
    "Purchased Subscription added successfully",
  msg_updatePurchasedSubscriptionSuccess:
    "Purchased Subscription updated successfully",
  err_getPurchasedSubscription: "Error in get purchased subscription details",

  msg_addConciergeSuccess: "Concierge added successfully",
  msg_updateConciergeSuccess: "Concierge updated successfully",
  msg_ConciergeDeleted: "Concierge deleted successfully",

  msg_requestDeleted: "Request deleted successfully",
  msg_requestUpdated: "Request updated successfully",

  company_exsits: "Client name already exsits",
  location_exsits: "Mfg. Facility location already exsits",

  // Pop-ups

  pop_employee_status_message:
    "Are You Sure You Want To Change Employee Status ?",
  pop_ok: "Yes",
  pop_cancel: "Cancel",

  // confirmAlertFacility

  confirmAlertFacility_title: "Confirm to save change ?",
  confirmAlertFacility_message: "Are you sure want to save the change ?",
  confirmAlertFacility_ok: "Yes",
  confirmAlertFacility_cancel: "No",

  // confirmAlertBrowser

  confirmAlertBrowser_title: "Leave site?",
  confirmAlertBrowser_message: "Changes you made may not be saved.",
  confirmAlertBrowser_ok: "Leave",
  confirmAlertBrowser_cancel: "Cancel",

  // Send Inquiry
  more: "More",
  moreInfo: "More info",
  sendInquiry: "Send Inquiry",
  sendinquiry_from_email: "From Email",
  ph_sendinquiry_from_email: "From Email",
  sendinquiry_to_email: "Inquiry To",
  ph_sendinquiry_to_email: "Inquiry To",
  sendinquiry_subject: "Subject",
  ph_sendinquiry_subject: "Please enter subject",
  val_msg_sendinquiry_subject: "Please enter subject",
  sendinquiry_details: "Details",
  ph_sendinquiry_details: "Please enter details",
  val_msg_sendinquiry_details: "Please enter details",

  site_selection: "Site Selection",
};
